var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2435_12823",
    transform: "translate(0 0.0238095) scale(0.0111111 0.010582)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2435_12823",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAACHElEQVR4nO3bTWpTURiH8UcdVJtUBZdgrTtyG36AOHAkuA/pQBfiUMWJWq0NdQspqNCB1kFuwY+kOdck/3N78/zgnZRDeO9DSFM4BUmSJEnr4ApwufYSfXUdeAp8AU6aGQFPgGsV9+qV2/wZ+O8ZATvVtuuJIXDA7Minsw8MKu3YC4+YH/l0HlbasRfeUh76TaUde+Eb5aG/VtqxyIXaC8xx0vJ8Z5/nYu0F1oWhQwwdYugQQ4cYOsTQIYYOMXSIoUMMHWLoEEOHGDrE0CGGDjF0iKFDDB1i6BBDhxg6xNAhbUMPgAdMbgUdUX655X+nrVXvM26e/T4rvOu3A+wFHua8zAdge6GiUwwx8rTZp/B+9qWSQ0xudd4pPLtObjC5H/hyWS84ov67p6tzUBKw5FLgBvAdv6HM8hPYBI7POmS8kJLQx8Dhqhc5xw6Z826G8nf07mK79NqzZb7YkMn3xtq/eLo2n4CrC3Sdahtj/z7vgJsLFT3DJnAPeM3kz9HaD5ueMfAKuNu0KNbZ//lonLQ839nn8etdiKFDDB1i6BBDhxg6xNAhhg4xdIihQwwdYugQQ4cYOsTQIYYOMXSIoUMMHWLoEEOHGDrE0CFdD33U4ux4ZVssQddDj1qcLboQXkvXQ79ocfb5yrZYAwPKLla+p+VdOP3rFvCR2ZH3WOGtznWzBTxm8jn8o5nPzc+2Ku7VaxvNSJIkSeq5XyOCL7V0KFDYAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.82ce4bf0ca03664a7529bfda9f05d6e7.svg";
export { ForwardRef as ReactComponent };